// Light/dark theme, persisted in localStorage and applied via <html data-theme>.
// The CSS `color-scheme` bound to data-theme also nudges the browser's built-in
// PDF/attachment rendering to match — the reason a "light" app keeps opened files
// readable instead of dark. Default is light.
import { tg } from "./telegram";

export type Theme = "light" | "dark";
const KEY = "docs-theme";

// Header/background colors handed to the Telegram chrome so the frame around the
// Mini App matches the in-app theme. Kept in sync with styles.css --bg.
const TG_BG: Record<Theme, string> = { light: "#e7f6f0", dark: "#0f1b18" };

export function getTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode / storage disabled — theme still applies for this session */
  }
  const t = tg();
  try {
    t?.setBackgroundColor?.(TG_BG[theme]);
    t?.setHeaderColor?.(TG_BG[theme]);
    t?.setBottomBarColor?.(TG_BG[theme]);
  } catch {
    /* older Telegram clients lack these setters */
  }
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}
